var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4636 27.0428C22.4639 27.7548 16.0497 23.2413 14.8213 23.2314C13.5928 23.2215 7.10642 27.6312 6.11844 26.9032C5.13046 26.1752 7.45316 18.6975 7.08301 17.5295C6.71286 16.3615 0.502536 11.5727 0.891555 10.4108C1.28066 9.24882 9.13033 9.14089 10.13 8.42886C11.1296 7.71692 13.7779 0.347597 15.0064 0.357432C16.2348 0.367352 18.7634 7.77832 19.7514 8.50634C20.7394 9.23428 28.5864 9.4686 28.9566 10.6366C29.3268 11.8046 23.0399 16.4929 22.6508 17.6548C22.2618 18.8167 24.4632 26.3308 23.4636 27.0428Z",
    fill: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRate);
export default __webpack_public_path__ + "static/media/empty-rate.017e0c76.svg";
export { ForwardRef as ReactComponent };